import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./GamePage.css";
import { FaHome, FaGamepad, FaHeadphonesAlt, FaTrophy, FaTrailer } from "react-icons/fa";

export default function MusicPage() {
  const navigate = useNavigate();
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await fetch("https://api.backofficemain.com/list_video.php?type=2");
        const data = await res.json();
        const formatted = data.map((v) => {
          const match = (v.videoLink || "").match(/(?:v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
          return { ...v, youtubeId: match ? match[1] : v.videoLink };
        });
        setVideos(formatted);
      } catch (err) {
        console.error("Failed to fetch videos:", err);
      }
    };
    fetchVideos();
  }, []);

  const handleVideoClick = (video) => {
    navigate("/viewvideo", { state: video });
  };

  return (
    <div className="container py-4">
      {/* Navigation */}
      <div className="d-flex justify-content-around text-center mb-4 menu-row">
        <div className="menu-btn" onClick={() => navigate("/")}>
          <FaHome className="menu-icon" />
          <span>Lobby</span>
        </div>
        <div className="menu-btn" onClick={() => navigate("/game")}>
          <FaGamepad className="menu-icon" />
          <span>Game</span>
        </div>
        <div className="menu-btn" onClick={() => navigate("/esport")}>
          <FaTrophy className="menu-icon" />
          <span>eSports</span>
        </div>
        <div className="menu-btn active" onClick={() => navigate("/music")}>
          <FaHeadphonesAlt className="menu-icon" />
          <span>Music</span>
        </div>
        <div className="menu-btn" onClick={() => navigate("/fullpage")}>
          <FaTrailer className="menu-icon" />
          <span>All</span>
        </div>
      </div>

      {/* Featured Section */}
      <h2 className="text-danger fw-bold mb-3 text-center">Featured Music</h2>
      <div className="row g-3 mb-5">
        {videos.slice(0, 2).map((video) => (
          <div key={video.id} className="col-md-6">
            <div
              className="card shadow-sm border-0 cursor-pointer"
              onClick={() => handleVideoClick(video)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={`https://img.youtube.com/vi/${video.youtubeId}/0.jpg`}
                className="card-img-top"
                alt="Music Video"
              />
              <div className="card-body text-center">
                <h6 className="fw-bold text-danger small mb-0">{video.title}</h6>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Grid Section */}
      <h2 className="text-danger fw-bold mb-3 text-center">Music Videos</h2>
      <div className="row g-4">
        {videos.slice(2).map((video) => (
          <div key={video.id} className="col-6 col-md-4 col-lg-3">
            <div
              className="card shadow-sm border-0 h-100"
              onClick={() => handleVideoClick(video)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={`https://img.youtube.com/vi/${video.youtubeId}/0.jpg`}
                className="card-img-top"
                alt="Music Video"
              />
              <div className="card-body text-center">
                <h6 className="fw-bold text-danger small mb-0">{video.title}</h6>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
